import React from "react";

import styles from "./CritterTile.module.css";

// tics aren't evenly spaced, so we are cheating.
const offsetLookup = (hour) => {
  const lookup = [
    5,
    9,
    16,
    19,
    26,
    30,
    37,
    41,
    48,
    51,
    58,
    62,
    69,
    73,
    80,
    83,
    90,
    94,
    101,
    104,
    111,
    115,
    122,
    126,
  ];
  return lookup[hour];
};

const endLookup = (hour) => {
  const lookup = [
    0,
    126,
    122,
    116,
    112,
    105,
    101,
    94,
    90,
    84,
    80,
    73,
    69,
    62,
    58,
    52,
    48,
    41,
    37,
    31,
    27,
    20,
    16,
    9,
    5,
  ];
  return lookup[hour];
};

const TimeBar = ({ start, end }) => {
  if (start === 0 && end === 0) {
    return null;
  }
  return (
    <div
      className={styles.timeFill}
      style={{
        left: `${offsetLookup(start)}px`,
        right: `${endLookup(end)}px`,
      }}
    />
  );
};

export default TimeBar;
